import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import BrandLogo from "@/components/BrandLogo";

export default function Login() {
  const { loginStep1 } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await loginStep1(email, password);
      if (data?.requires_otp === false) {
        toast.success("Bu cihaz güvenilir — doğrudan giriş yapıldı");
        nav("/");
      } else if (data?.requires_otp) {
        toast.success("Doğrulama kodu e-postanıza gönderildi");
        nav(`/login/otp?email=${encodeURIComponent(data.email)}`);
      }
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail, "Giriş yapılamadı."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-6">
      <div className="w-full max-w-[420px]" data-testid="login-page">
        <div className="mb-10">
          <BrandLogo size="lg" />
        </div>

        <h1 className="text-3xl tracking-tight font-bold text-slate-900 mb-2">Giriş Yap</h1>
        <p className="text-sm text-slate-500 mb-8">E-posta ve şifrenizle devam edin.</p>

        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="block text-xs font-semibold tracking-wider uppercase text-slate-400 mb-2">E-posta</label>
            <input
              type="email"
              required
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="ornek@ajans.com"
              data-testid="login-email"
              className="w-full h-11 rounded-lg border border-slate-200 bg-white px-4 text-sm focus:outline-none focus:ring-1 focus:ring-slate-400 focus:border-slate-400 placeholder:text-slate-400"
            />
          </div>
          <div>
            <div className="flex items-center justify-between mb-2">
              <label className="text-xs font-semibold tracking-wider uppercase text-slate-400">Şifre</label>
              <Link to="/forgot-password" data-testid="forgot-link" className="text-xs text-slate-500 hover:text-slate-900 transition-colors">
                Şifremi Unuttum
              </Link>
            </div>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              data-testid="login-password"
              className="w-full h-11 rounded-lg border border-slate-200 bg-white px-4 text-sm focus:outline-none focus:ring-1 focus:ring-slate-400 focus:border-slate-400 placeholder:text-slate-400"
            />
          </div>

          {error && (
            <div data-testid="login-error" className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg px-4 py-3">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full rounded-full bg-slate-900 text-white hover:bg-slate-800 h-11 font-medium transition-colors duration-150 disabled:opacity-50"
          >
            {loading ? "Kod gönderiliyor..." : "Devam Et"}
          </button>
        </form>

        <p className="mt-8 text-xs text-slate-400">
          İki adımlı doğrulama etkin. Şifrenizi girdikten sonra e-postanıza gönderilen 6 haneli kodu doğrulamanız gerekir.
        </p>
      </div>
    </div>
  );
}
